export default "assets/marker-d557f57e.svg";